module.exports = __webpack_public_path__ + "img/filter-list.c2c0d569.svg";